import Immerable from "./immerable";

export class TextEditorFile extends Immerable {
    // full path for the file, including file name
    public filePath: string;

    // set true to allow writing into this file; set false to mark it as read-only
    public allowWrite: boolean;

    // description about the file shown in UI
    public description: string | undefined;

    // file contents
    public fileContents: string;

    // original file contents, never to be modified
    public originalFileContents: string;

    // set to true if this file is currently being loaded in
    public isLoadingFile: boolean;

    // has the file been loaded in?
    public isLoaded: boolean;

    // user has made (unsaved) modifications to the file
    public isModified: boolean;

    // if non-null there was an error saving the file
    public errorSavingFile: string | null;

    constructor(filePath: string, allowWrite: boolean, description?: string) {
        super();

        this.filePath = filePath;
        this.allowWrite = allowWrite;
        this.description = description;
        this.fileContents = '';
        this.originalFileContents = '';
        this.isLoadingFile = false;
        this.isLoaded = false;
        this.isModified = false;
        this.errorSavingFile = null;
    }
}

export class SystemFileQuery extends Immerable {

    // path or pattern to find file or files
    // examples:
    // '/etc/systemd/timesyncd.conf'
    // '/{lib,etc,run}/netplan/*.yaml'
    public queryPattern: string;

    // set true to allow writing into these files; set false to mark them as read-only
    public allowWrite: boolean;

    // description about the file(s) shown in UI
    public description: string | undefined;

    constructor(queryPattern: string, allowWrite: boolean, description?: string) {
        super();

        this.queryPattern = queryPattern;
        this.allowWrite = allowWrite;
        this.description = description;
    }
}